"use strict";
angular.module("broadcastToBeCompiledRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.broadcast.waitcompiled', {
            url: '/waitcompiled?siteid',
            views: {
                "main@front.editctr": {
                    templateUrl: "./editingCenter/broadcast/toBeCompiled/main_tpl.html",
                    controller: "broadcastToBeCompiledCtrl"
                }
            }
        }).state('broadcastmanuscript', {
            url: "/broadcastmanuscript?broadcastchannelid&broadcastchnldocid&broadcastmetadataid&broadcastsiteid&broadcastplatform",
            views: {
                '': {
                    templateUrl: './editingCenter/broadcast/toBeCompiled/manuscript/manuscript_tpl.html',
                    controller: "broadcastManuscriptCtrl"
                }
            }
        }).state('broadcastplannedorder', {
            url: "/broadcastplannedorder?broadcastchannelid&broadcastchnldocid&broadcastmetadataid&broadcastsiteid&broadcastplatform",
            views: {
                '': {
                    templateUrl: './editingCenter/broadcast/toBeCompiled/plannedOrder/plannedOrder_tpl.html',
                    controller: "broadcastPlannedOrderCtrl"
                }
            }
        })
    }])